import { DefaultButton } from "@fluentui/react";
import { useRef, useEffect } from "react";
import InvoiceLabelFooterView from "./InvoiceLabelFooterView";
import InvoiceLabelHeaderView from "./InvoiceLabelHeaderView";
import telegram from "../../../../assets/images/bees telegram.png"
import { Utils } from "../../../common/views/Utils";
import { PrintInvoiceLabelModel } from "../../models/InvoiceModel";
import { useInvoicePrintVM } from "../../viewmodels/InvoicePrintVM";
import { QRCodeSVG } from "qrcode.react";

type InvoicePrintLabelProps = {
    ids: string;
}

export default function InvoiceLabelView({ ids }: InvoicePrintLabelProps) {
    const hasLoaded = useRef(false);
    const vm = useInvoicePrintVM();

    useEffect(() => {
        console.log("invoice print loaded");
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        console.log("invoice get labels");
        vm.getLabels(ids);
    }, [vm, ids]);

    const col1Class = "grid-col label2-col1";
    const col2Class = "grid-col label2-col2";
    const col4Class = Utils.getColumnWidth(4);

    const printRow = (invoice: PrintInvoiceLabelModel) => {
        return <div className="invoice-print-label2 pl-5">
            <div>
                <InvoiceLabelHeaderView sender={vm.senderNumber} invoice={invoice} />

                <div className="">
                    <div className={col1Class}>ឈ្មោះ</div>
                    <div className={col2Class + " label2-name-font"}>{invoice.customer}</div>
                </div>

                <div className="pt-5">
                    <div className={col1Class}>អាសយដ្ឋាន</div>
                    <div className={col2Class + " label2-name-font"}>{invoice.address}</div>
                </div>
                <div className="pt-5">
                    <div className={col1Class}>វិ ក័យបត្រ</div>
                    <div className={col2Class + " label2-name-font"}>
                        {Utils.formatAccountNumber(invoice.id)}
                    </div>
                </div>
            </div>

            <div className="pv-10">
                <InvoiceLabelFooterView exchangeRate={vm.rielsExchangeRate} invoice={invoice} />
            </div>

            {invoice.consolidated && <div className="pt-10 center">បង្រួមកញ្ចប់ទំនិញ</div>}

            <div className="p-10 center">
                ប្រយ័ត្ន​បាក់បែក​ កុំអោយត្រូវក្តៅរឺសើម
            </div>

            <div className="ms-Grid-row small">
                <div className={col4Class}>
                    <div className="pl-10"><img src={telegram} alt="Bees Telegram" width={50} /></div>
                    <div style={{ paddingLeft: 13 }}>Telegram</div>
                </div>

                <div className={col4Class + " center pt-10"} style={{ fontSize: "smaller" }}>
                    Please visit Telegram Channel and Website
                </div>

                <div className={col4Class + " right"}>
                    <div className="pr-10">
                        <QRCodeSVG value="https://bees.express" size={50} level="H" />
                    </div>
                    <div className="pr-15">Website</div>
                </div>
            </div>
        </div>;
    }

    const printButton = () => {
        return <>
            <DefaultButton
                text="Print"
                iconProps={{ iconName: "print" }}
                onClick={() => window.print()}
                className="no-print"
            />
        </>;
    }

    return <div>
        {printButton()}

        <div>
            {vm.labels.map((invoice: PrintInvoiceLabelModel, index: number) => {
                return <>
                    {index > 0 && <div className="page-break"></div>}
                    <div className="pt-10">{printRow(invoice)}</div>
                </>;
            })}
        </div>
    </div>;
}